import { useState, useCallback } from 'react';
import { useToast } from 'context/tostifyContext';
import customAxios, { customFormAxios } from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useContractDocs = contractUniqueID => {
  const [docs, setDocs] = useState([]);
  const [uploading, setUploading] = useState(false);
  const { showToast } = useToast();

  const fetchDocs = useCallback(async () => {
    if (!contractUniqueID) return;
    try {
      const res = await customAxios.get(`/Ops/GetContractsDocs/${contractUniqueID}`, { headers: authHeader() });
      setDocs(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Error fetching contract docs:', err);
      setDocs([]);
    }
  }, [contractUniqueID]);

  const uploadDoc = async file => {
    if (!file || !contractUniqueID) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('contractUniqueID', contractUniqueID);
      formData.append('docName', file.name);
      formData.append('doc', file);
      formData.append('docType', 'Contract');

      await customFormAxios.post('/Ops/AddContractsDocs', formData, {
        headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
      });
      showToast(`${file.name} uploaded successfully`);
      await fetchDocs();
    } catch (err) {
      console.error('Upload error:', err);
      showToast('Error uploading file', 'error');
    } finally {
      setUploading(false);
    }
  };

  const downloadDoc = async (docId, fileName) => {
    await customAxios
      .get(`/Ops/GetContractsFile/${docId}`, {
        headers: authHeader(),
        responseType: 'blob',
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const deleteDoc = async docId => {
    try {
      await customAxios.post('/Ops/DeleteContractsDocs', { id: docId }, { headers: authHeader() });
      showToast('Document removed');
      await fetchDocs();
    } catch (err) {
      console.error('Delete error:', err);
      showToast('Error removing document', 'error');
    }
  };

  return { docs, uploading, fetchDocs, uploadDoc, downloadDoc, deleteDoc };
};

export default useContractDocs;
